import { Validator } from "devextreme-react";
import { RequiredRule } from "devextreme-react/data-grid";
import TextArea, { ITextAreaOptions } from "devextreme-react/text-area";
import InputProps from "interfaces/InputProps";
import { useEffect, useState } from "react";
import { ControlSize } from "shared/enums/ControlSizeEnum";
import { GetNewId } from "shared/utility/CommonUtility";
import { getControlRadius } from "shared/utility/ControlUtility";

export default function PromTextarea(props: ITextAreaOptions & InputProps) {
  const { controlRef, onValidated, className, ...rest } = props;

  const [validatorRules, setValidatorRules] = useState<any[]>([]);

  const { required, label, id, radiusSize } = props;

  useEffect(() => {
    const setValidationRules = () => {
      const rules = [];
      if (required) {
        const rule = (
          <RequiredRule
            key={`${GetNewId()}-${id}`}
            message={`${label} is required.`}
          />
        );
        rules.push(rule);
      }

      setValidatorRules(rules);
    };

    setValidationRules();
  }, [id, label, required]);

  const getClassNames = () => {
    let classes = `prom-control border-1.5 border-silver outline-none ${getControlRadius(
      radiusSize
    )}`;
    return classes;
  };

  return (
    <TextArea ref={controlRef} {...rest} className={getClassNames()}>
      <Validator onValidated={onValidated}>{validatorRules}</Validator>
    </TextArea>
  );
}

PromTextarea.defaultProps = {
  radiusSize: ControlSize.Large,
};
